<template>
  <div class="filePage" v-if=" filesData && filesData.baseAnnexes.length > 0 ">
    <p class="fgx"></p>
    <van-cell-group class="baseNone baseSalary accessoryBox">
      <p class="tit">附件</p>
      <!-- <p v-if="files.length == 0" class="noneFile">暂无附件</p> -->
      <div class="detailMian">
        <ul>
          <li class="clearfix" v-for="(item, index) in files" :key="index">
            <dl class="fl">
              <dt @click="Showswiper(index)">
                <img
                  :src="
                    getFormat(item.fileName) == 'jpg' ||
                    getFormat(item.fileName) == 'png' ||
                    getFormat(item.fileName) == 'jpeg'
                      ? item.url
                      : getFormat(item.fileName) == 'pdf'
                      ? '' + baseUrl + 'searchImg/pdf.png'
                      : getFormat(item.fileName) == 'xlsx' ||
                        getFormat(item.fileName) == 'xls'
                      ? '' + baseUrl + 'searchImg/excel.png'
                      : '' + baseUrl + 'searchImg/word.png'
                  "
                  alt
                />
              </dt>
              <dd class="dtName">{{ item.fileName }}</dd>
              <dd class="Mb">
                <span>{{ getMb(item.fileSize) }}</span>
              </dd>
            </dl>
            <!-- 微信内浏览器不支持下载  去别的浏览器打开 -->
            <a
              href="javascript:void(0);"
              class="downloadBtn fr"
              @click="downLoad(item)"
              >下载</a
            >
          </li>
        </ul>
      </div>
    </van-cell-group>
    <van-overlay :show="weixnShow" @click="weixnShow = false">
      <div class="wrapper weixnPage">
        <van-image :src="baseUrl + 'img/share.png'" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
/* eslint-disable */
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "fileView",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      files: [],
      commonType: "",

      clientType: getDeviceType(), //手机类型
      weixnShow: false,
    };
  },

  props: {
    filesData: {
      type: Object,
      default() {
        {
        }
      },
    },
  },
  mounted() {
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.$nextTick(() => {
      if (this.filesData && this.filesData.baseAnnexes) {
        this.files = this.filesData.baseAnnexes;
      }
    });
    console.log(this.files,"mounted")
  },
  methods: {
    //获取文件后缀名
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    getMb(Kb) {
      //计算附件大小
      let size = "";
      size = (Kb / 1024).toFixed(2) + "kB";
      return size;
    },

    Showswiper(showIndex) {
      //查看预览图片
      let magnifyList = [];
      let _this = this;
      _this.files.forEach(SelectBigImgs);
      function SelectBigImgs(item) {
        if (
          _this.getFormat(item.fileName) == "jpg" ||
          _this.getFormat(item.fileName) == "png" ||
          _this.getFormat(item.fileName) == "jpeg"
        ) {
          magnifyList.push(item.url);
        }
      }
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true,
      };
      if (magnifyList.length > 0) {
        this.$store.commit("setDataImgs", data);
      }
    },
    //下载附件
    downLoad() {
      this.weixnShow = true;
      //提示去浏览器打开
    },
  },
  watch: {
    filesData: {
      handler(val) {
        if (val && val.baseAnnexes) {
          this.files = val.baseAnnexes;
            console.log(this.files,"watch")
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.filePage {
   
  .van-overlay {
    z-index: 9999;
    overflow: hidden;
  }
  .weixnPage{
    position: relative;
    width: 100%;
    height: 100%;
    .van-image{
      position: absolute;
      right: 10px;
      top: 0;
    }
  }
  > p.fgx {
    width: 100%;
    height: 10px;
    background-color: #f6f6f6;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    border: 0 none;
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .accessoryBox {
    padding-bottom: 8px;
    > p {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #e0e0e0;
      a.recordImg {
        font-size: 14px;
        display: inline-block;
        position: absolute;
        top: 0;
        right: 12px;
        color: #3c78f9;
        font-weight: 400;
      }
    }
    > p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 21px;
      background: #2581d6;
      top: 12px;
      left: 16px;
    }
    .noneFile {
      font-size: 14px;
      padding: 0 16px;
      color: #333;
      text-align: left;
    }
    .detailMian {
      padding: 0 16px;
      width: 100%;
      margin-top: 10px;

      li {
        width: 100%;
        min-height: 40px;
        margin: 10px 0;

        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;
            img {
              width: 100%;
              height: 100%;
            }
          }

          dd {
            display: block;
            font-size: 10px;
            color: #999;
            position: absolute;
          }

          dd.dtName {
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            /*设置内容不换行*/
            text-overflow: ellipsis;
            font-size: 12px;
            color: #666;
            top: 0px;
            left: 50px;
          }
          dd.Mb {
            top: 17px;
            left: 50px;
          }
        }
      }

      a {
        display: block;
        font-size: 12px;
        color: #35c476;
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
      a.delBtn {
        color: #f34646;
      }
    }
  }
}
</style>